import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { Dialog } from '../../../../../components/molecules/dialog';

import { useDeleteAttachment } from '@/features/visits/hooks/mutation/use-delete-attachment';

interface Props {
  open: boolean;
  onCancel: () => void;
  selectedAttachments: number[];
  visitId: number;
}

export const DeleteAttachmentDialog = ({ onCancel, open, selectedAttachments, visitId }: Props) => {
  const { t } = useTranslation(['visit']);

  const { mutateAsync: deleteAttachment, isPending } = useDeleteAttachment();

  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      onConfirm={async () => {
        try {
          const deleteAttachmentsMutations = selectedAttachments.map(attachmentId =>
            deleteAttachment({ visitId, attachmentId }),
          );

          await Promise.allSettled(deleteAttachmentsMutations).then(results => {
            const statuses = results.map(result => result.status);
            const hasRejected = statuses.includes('rejected');
            const hasFulfilled = statuses.includes('fulfilled');

            if (hasRejected && !hasFulfilled) {
              toast.error(t('visit:attachments.dialog.delete.failed'));
            }
            if (hasRejected && hasFulfilled) {
              toast.error(t('visit:attachments.dialog.delete.warning'));
            }
            if (!hasRejected && hasFulfilled) {
              toast.success(t('visit:attachments.dialog.delete.success'));
            }
          });
          onCancel();
        } catch (error) {
          console.error(error);
        }
      }}
      title={t('visit:attachments.dialog.delete.title')}
      variant="warning"
      isConfirmButtonDisabled={isPending}>
      {t('visit:attachments.dialog.delete.description')}
    </Dialog>
  );
};
